import React, { useLayoutEffect, useEffect, useState, useRef,createRef} from "react";
import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import {addCalenderItem, hideModal} from '@/reducers/ModalPopup';
import store from "@/redux/store";
import CalenderMonth from "./CalenderMonth";
import { v4 as uuid } from "uuid";

export default function Calender({...props}) {
    const mref = useRef(null);
   const addCalenderItemEvent=(event, eventTypeId) => {
        if(props?.onNewItemHandler) {
            props.onNewItemHandler(event, eventTypeId);
        }
        store.dispatch( addCalenderItem({priorities:props?.priority,onCloseEvent:closeEventHandler, onSaveEvent: onSaveEventHandler, scheduleTask: onScheduleTaskEvent, checkAvailability: checkAvailability }) );
        }    
        
        const checkAvailability=(event, fromDate, workhours) => {
            
            if (mref.current) {
                mref.current.getAvailability(fromDate, workhours)
            }
            
            }
        
        
    const closeEventHandler=(event) => {
        store.dispatch( hideModal(null) );
        }    
        
        const onSaveEventHandler=(event) => {
            if(props?.onSubmitHandler) {
                props?.onSubmitHandler(event);
            }
            //store.dispatch( hideModal(null) );
        }
        
        const onScheduleTaskEvent=(data) => {
            if (mref.current) {
                mref.current.setCurrentValue(data)
            }
        }    
        
    return (
        <>
            <CalenderMonth
                ref={mref} 
                {...props} 
                key={uuid().slice(0, 8)} 
                showAddItemHandler={addCalenderItemEvent} 
                items={props?.items} 
                getValues={props?.getValues} 
                setValue={props?.setValue} 
                showPreviewHandler={props?.showPreviewHandler}
                saveItemHandler={props?.saveItemHandler}
                calenderSettings={props.calenderSettings}
                event_types={props?.event_types}
                selectedDate={props?.selectedDate}
                users={props?.users}
                selectedUsers={props?.selectedUsers}
            />
        </>
        
    )
}